export default __webpack_public_path__ + "static/media/Kings.ada3be8c.png";